import * as React from 'react';
import { makeStyles, Skeleton, SkeletonItem, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
    rows: {
        display: 'flex',
        flexDirection: 'column',
    },
    row: {
        display: 'grid',
        gridTemplateColumns: '32px minmax(0, 3fr) minmax(0, 1.4fr) minmax(0, 1.4fr) 90px 60px',
        alignItems: 'center',
        gap: '16px',
        paddingTop: '14px',
        paddingBottom: '14px',
        paddingLeft: '16px',
        paddingRight: '16px',
        borderTop: `1px solid ${tokens.colorNeutralStroke2}`,
        '@media (max-width: 767px)': {
            gridTemplateColumns: '32px minmax(0, 1fr) 60px',
        },
    },
    hideMobile: {
        '@media (max-width: 767px)': { display: 'none' },
    },
    cards: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))',
        gap: '12px',
    },
    card: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        padding: '16px',
        backgroundColor: tokens.colorNeutralBackground1,
        border: `1px solid ${tokens.colorNeutralStroke2}`,
        borderRadius: tokens.borderRadiusLarge,
    },
    block: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
    },
});

export const TableSkeleton: React.FC<{ rows?: number }> = ({ rows = 6 }) => {
    const styles = useStyles();
    return (
        <Skeleton aria-label="Загрузка списка" className={styles.rows}>
            {Array.from({ length: rows }, (_, i) => (
                <div key={i} className={styles.row}>
                    <SkeletonItem shape="square" size={32} />
                    <SkeletonItem size={16} style={{ width: `${55 + ((i * 17) % 35)}%` }} />
                    <SkeletonItem size={12} className={styles.hideMobile} style={{ width: '70%' }} />
                    <SkeletonItem size={12} className={styles.hideMobile} style={{ width: '60%' }} />
                    <SkeletonItem size={12} className={styles.hideMobile} />
                    <SkeletonItem size={12} />
                </div>
            ))}
        </Skeleton>
    );
};

export const CardsSkeleton: React.FC<{ count?: number }> = ({ count = 4 }) => {
    const styles = useStyles();
    return (
        <Skeleton aria-label="Загрузка" className={styles.cards}>
            {Array.from({ length: count }, (_, i) => (
                <div key={i} className={styles.card}>
                    <SkeletonItem size={16} style={{ width: '70%' }} />
                    <SkeletonItem size={12} style={{ width: '45%' }} />
                    <SkeletonItem size={12} style={{ width: '90%' }} />
                    <SkeletonItem size={12} style={{ width: '60%' }} />
                </div>
            ))}
        </Skeleton>
    );
};

export const BlockSkeleton: React.FC<{ lines?: number }> = ({ lines = 5 }) => {
    const styles = useStyles();
    return (
        <Skeleton aria-label="Загрузка" className={styles.block}>
            {Array.from({ length: lines }, (_, i) => (
                <SkeletonItem key={i} size={16} style={{ width: `${45 + ((i * 23) % 50)}%` }} />
            ))}
        </Skeleton>
    );
};
